export default __webpack_public_path__ + "static/media/section3.255a8253.jpg";